export const formattedDate = (date) => {
    if (date) {
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric'
        }).format(new Date(date))
    }
}

export const isProfileComplete = ({firstName, lastName}) => {
    const hasValue = (entity) => {
        if (!entity || typeof entity !== 'string') {
            return false
        }
        return entity?.trim() !== ''
    }
    return hasValue(firstName) && hasValue(lastName)
}

export const todayEndOfDay = () => {
    const today = new Date()
    const year = today.getUTCFullYear()
    const month = String(today.getUTCMonth() + 1).padStart(2, '0')
    const day = String(today.getUTCDate()).padStart(2, '0')
    return `${year}-${month}-${day}T23:59:59Z`
}
